import React, { forwardRef, memo } from 'react';
import cn from 'classnames';

import { Icon } from 'components';
import type { SelectionProps } from '../Selection';
import Selection from '../Selection';

import styles from './TickCheckbox.module.scss';

export type TickCheckboxProps = Omit<SelectionProps, 'type'>;

export const TickCheckbox = memo(
  forwardRef<HTMLInputElement, TickCheckboxProps>(
    ({ className = '', style, children, ...props }, ref) => {
      const contentClassNames = cn(styles.TickCheckbox, className);

      return (
        <Selection
          {...props}
          className={contentClassNames}
          style={style}
          type="checkbox"
          dataTestid="TickCheckbox"
          ref={ref}
        >
          {children}
          <Icon iconName="plus-circle" className={styles.untick} />
          <Icon iconName="tick-mark-circle" className={styles.tick} />
        </Selection>
      );
    }
  )
);

TickCheckbox.displayName = 'TickCheckbox';
